import { Component, h, Prop } from '@stencil/core'

@Component({
  tag: 'envc-table-of-contents-item',
  styleUrl: 'envc-table-of-contents-item.scss',
  shadow: true
})
export class EnvcTableOfContentsItem {
  @Prop() linkHref: string
  @Prop() linkTitle: string
  @Prop() backgroundColor: string

  onAnchorLinkClicked(event: MouseEvent) {
    const isAnchorLink = this.linkHref.includes('#')

    if (isAnchorLink) {
      event.preventDefault()

      const anchorLinkValue = this.linkHref.split('#')[1]

      anchorLinkValue && document.querySelector(`[id="${anchorLinkValue}"]`)
        .scrollIntoView({ behavior: 'smooth' })
    }
  }

  render() {
    const highlightClasses = [
      'color-background-1',
      'color-background-4',
      'color-background-5',
      'color-background-24'
    ];

    const linkColor = highlightClasses.includes(this.backgroundColor)
      ? 'var(--themePrimaryColor)'
      : '#fff';

    return (
      <li style={{ color: linkColor }}>
        <a
          data-scroll
          href={this.linkHref}
          style={{ color: linkColor }}
          onClick={this.onAnchorLinkClicked.bind(this)}
        >
          {this.linkTitle}
        </a>
      </li>
    )
  }
}
